export default class CustomerLimit {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.registrationId = jsonResponse["registrationId"];
        this.dailyLimit = jsonResponse["dailyLimit"];
        this.monthlyLimit = jsonResponse["monthlyLimit"];

    }

}